module.exports = __webpack_public_path__ + "static/img/3_v3.649c5b61.png";